const Index = ({ children }: { children: React.ReactNode }): JSX.Element => (
  <div className="flex flex-col justify-around lg:flex-row">{children}</div>
)

export default Index
